<template>
    <div class="no-data access module-access-denied">
        <font-awesome-icon :icon="['fas', 'lock']" class="lock-icon" />
        <div v-if="props.accessLevelMessages?.length">
            <div
                v-for="(accessLevelMessage, index) in props.accessLevelMessages"
                :key="index"
                class="access-series"
            >
                <span class="series">{{ accessLevelMessage.seriesName }}</span>
                series requires
                <span class="level">{{ accessLevelMessage.accessLevel }}</span>
                access.
            </div>
        </div>
        <div
            v-else
            v-html="props.message || 'You do not have access to this module.'"
        />
        <div>To request access, please contact us.</div>
        <primevue-button @click="showFeedback = true">
            Contact us
        </primevue-button>
        <primevue-button
            v-if="props.editDashboardMode"
            severity="secondary"
            @click="emit('delete:module')"
        >
            Remove module
        </primevue-button>
    </div>
    <central-modal
        header="Feedback"
        v-model:visible="showFeedback"
    >
        <feedback-overlay @close:overlay="showFeedback = false" />
    </central-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import PrimevueButton from 'primevue/button';
import CentralModal from '@/components/common/CentralModal.vue';
import FeedbackOverlay from '@/components/powerMarkets/overlays/FeedbackOverlay.vue';

interface AccessLevelMessage {
    seriesName: string;
    accessLevel: string;
}

const props = defineProps<{
    message?: string | null;
    accessLevelMessages?: AccessLevelMessage[];
    editDashboardMode?: boolean;
}>();

const emit = defineEmits<{ 'delete:module': [] }>();
const showFeedback = ref(false);
</script>

<style lang="scss" scoped>
.no-data {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--largeSpacing);
    text-align: center;

    &.access {
        font-size: var(--smallFontSize);
        padding: var(--defaultSpacing);

        .access-series {
            margin-bottom: var(--smallSpacing);
        }

        .lock-icon {
            font-size: 4rem;
            color: var(--lcpSunrise);
            flex-shrink: 0;
        }

        .series,
        .level {
            font-weight: var(--boldFontWeight);
        }
    }
}
</style>
